import { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  PaginationItem,
} from '@mui/material';

import { TableHeadCell } from '../table-cells/TableCells';
import LocalDomainTableRow from './LocalDomainTableRow';
import Search from '../UI/search/Search';

import {
  useGetAuthenticationQuery,
  useGetLocalDomainsQuery,
} from '../../services/ADapi';
// import { setSearchQuery } from '../../store/localDomainsReducer';

import { PreviousPageIcon, NextPageIcon } from '../../PaginationIcons';

const filterLocalDomains = (localDomains, searchQuery) => {
  const lowerCaseSearchQuery = searchQuery.toLowerCase();

  if (localDomains) {
    return localDomains.filter(({ domain }) => {
      return domain.toLowerCase().includes(lowerCaseSearchQuery);
    });
  }

  return [];
};

const LocalDomainsTable = () => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const { data, isLoading } = useGetLocalDomainsQuery(user_id);

  const pageHandler = (_e, value) => {
    setPage(value);
  };

  const searchHandler = (e) => {
    setSearchQuery(e.target.value);
  };

  const localDomains = filterLocalDomains(data, searchQuery);

  const ITEMS_PER_PAGE = 5;
  const paginatedDomains = localDomains.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const pagesLeftAfterDeletion = localDomains.length % ITEMS_PER_PAGE;

  useEffect(() => {
    if (searchQuery.length > 0 || pagesLeftAfterDeletion === 0) {
      setPage(1);
    }
  }, [searchQuery, pagesLeftAfterDeletion]);

  if (isLoading) {
    return <h2>Loading...</h2>;
  }

  return (
    <>
      <Search
        placeholder="Search"
        cb={searchHandler}
        sx={{ maxWidth: '216px' }}
      />
      <TableContainer sx={{ pt: 3 }}>
        <Table sx={{ minWidth: '650px' }}>
          <TableHead>
            <TableRow>
              <TableHeadCell>Name</TableHeadCell>
              <TableHeadCell align="left">Domain Controller</TableHeadCell>
              <TableHeadCell></TableHeadCell>
              <TableHeadCell></TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedDomains.map(({ id, controller_ids, domain }) => (
              <LocalDomainTableRow
                key={`${id}-local-domain`}
                id={id}
                name={domain}
                controllerIds={controller_ids}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {localDomains.length > ITEMS_PER_PAGE ? (
        <Pagination
          count={Math.ceil(localDomains.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={pageHandler}
          sx={{ ml: 'auto' }}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              slots={{
                next: NextPageIcon,
                previous: PreviousPageIcon,
              }}
            />
          )}
        />
      ) : null}
    </>
  );
};

export default LocalDomainsTable;
